import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getUserAccessSettings(id, locationId) {
	const query = gql`
		query getUser($_id: String!, $locationId: String!) {
			getUser(_id: $_id, locationId: $locationId) {
				_id
				fullName
				auth {
					_id
					locationId
					actions {
						_id
						actionKey
						actionName
						actionDescription
						category
					}
					groups {
						_id
						locationId
						groupName
						groupDescription
						groupActions
					}
				}
			}
		}
	`;

	const variables = {
		_id: id,
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUser;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
